import React from 'react';
import {Grid} from '@material-ui/core';
import InputField from "../../../../FormikUtils/InputField";

export default function PolizaForm(props) {
    const {
        formField: {
            numeroSolicitud,
            premium
        }
    } = props;

    return (
        <React.Fragment>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={12}>
                    <InputField
                        name={numeroSolicitud.name}
                        label={numeroSolicitud.label}
                        textTransform={'uppercase'}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} sm={12}>
                    <InputField
                        name={premium.name}
                        label={premium.label}
                        textTransform={'lowercase'}
                        fullWidth
                    />
                </Grid>
            </Grid>
        </React.Fragment>
    );
}